<template>
  <div id="most-visited" class="most-visited">
    <div class="most-visited__container">
      <div class="most-visited__list">
        <a
          v-for="(mostVisitedSite, index) in props.tilesList"
          :key="mostVisitedSite.id"
          v-shortcut-ad
          class="most-visited__site dark:text-radio_group_text_color_dark"
          target="_blank"
          :href="`${mostVisitedSite['click_url'] + '&custom-data=' + customData}`"
          :data-tile-index="index"
          :data-tile-brand="mostVisitedSite['name']"
          @click="shortcutAdClick(index, mostVisitedSite['name'])"
        >
          <div class="most-visited__site-icon">
            <img
              class="most-visited__site-favicon"
              :alt="`${mostVisitedSite['name']}`"
              tabindex="-1"
              :src="`${mostVisitedSite['image_url']}`"
            />
          </div>
          <div
            class="most-visited__site-link-text text-onelaunch_dark_shades_400 dark:text-radio_group_text_color_dark"
          >
            {{ mostVisitedSite['name'] }}
          </div>
          <img :src="`${mostVisitedSite['impression_url']}`" width="1" height="1" />
        </a>
      </div>
    </div>
  </div>
</template>
<script setup>
  import $ from 'jquery'
  import { incrementProfileProperty, setProfileProperty } from '~~/assets/js/newtabpage'
  import { sendMixpanelEvent } from '~/utils/host-browser-apis'

  const mostVisited = ref([])
  const props = defineProps({
    isNewsAdded: {
      type: Boolean,
      default: false,
    },
    customData: {
      type: String,
      default: '',
    },
    tilesList: {
      type: Array,
      default: () => [],
    },
    provider: {
      type: String,
      default: '',
    },
    enhancedHeaderDesign: {
      type: Boolean,
      default: false,
    },
  })

  const noContentMarginTop = props.isNewsAdded ? '60px' : '128px'
  const mvMarginTop = props.isNewsAdded ? '0px' : '16px'
  let mvMarginBottom = props.isNewsAdded ? '60px' : '0'
  let mvPaddingTop = props.isNewsAdded ? '63px' : '76px'
  let mvSitePadding = '16px 12px'

  if (props.enhancedHeaderDesign) {
    mvPaddingTop = 0
    mvMarginBottom = 0
    mvSitePadding = '12px 12px'
  }

  onMounted(() => {
    for (let i = 0; i < props.mostVisited?.length; i++) {
      incrementProfileProperty('ntp_shortcutAdImpressions', 1)
    }

    const removeMostVistedSpace = () => {
      if (props.tilesList === undefined && $('#most-visited').hasClass('most-visited')) {
        $('#most-visited').attr('class', 'most-visited-no-content')
      } else {
        setTimeout(removeMostVistedSpace, 1)
      }
    }
    removeMostVistedSpace()
    setProfileProperty('ntp_pinnedshortcut', mostVisited.value?.length.toString() ?? '0')
    setProfileProperty('Provider', props.provider)
  })

  const shortcutAdClick = async (index, mostVisitedSiteName) => {
    await sendMixpanelEvent('NtpShortcutAd_Clicked', {
      ntp_tile_provider: props.provider.toLowerCase(),
      ntp_tile_brand: mostVisitedSiteName,
      ntp_tile_position: index,
    })
    incrementProfileProperty('ntp_shortcutAdClicks', 1)
  }

  const vShortcutAd = {
    mounted: async (element) =>
      await sendMixpanelEvent('NtpShortcutAd_Rendered', {
        ntp_tile_provider: props.provider.toLowerCase(),
        ntp_tile_brand: element?.dataset?.tileBrand,
        ntp_tile_position: element?.dataset?.tileIndex,
      }),
  }
</script>

<style lang="scss" scoped>
  /* stylelint-disable value-keyword-case */

  .most-visited-no-content {
    margin-top: 128px;
    width: 100%;
  }

  .most-visited {
    padding-top: v-bind(mvPaddingTop);
    width: 100%;
    margin-bottom: v-bind(mvMarginBottom);
    margin-top: v-bind(mvMarginTop);

    &__container {
      margin: 0 auto;
      max-width: 560px;
    }

    &__list {
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      -ms-flex-pack: center;
      justify-content: center;
      padding-left: 0;
    }

    &__site {
      cursor: pointer;
      float: left;
      padding: v-bind(mvSitePadding);
      position: relative;
      width: 112px;
      height: 112px;
      text-decoration: none;

      &:hover {
        background-color: var(--mv-hover-bgcolor);
        border-radius: 4px;
      }
    }

    &__site-icon {
      align-items: center;
      background: var(--mv-icon-bgcolor);
      border: 1px solid transparent;
      border-radius: 50%;
      box-shadow: 0 1px 5px -2px rgb(0, 0, 0, 25%);
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      height: 48px;
      justify-content: center;
      margin: 8px auto 13px;
      transition: box-shadow 0.3s ease-in-out;
      width: 48px;
      overflow: hidden;
    }

    &__site-link-text {
      font-size: 14px;
      line-height: 117%;
      margin: 0 auto 16px;
      pointer-events: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @media only screen and (max-width: 425px) {
    .most-visited {
      padding: 76px 0 0.8em;
    }
  }

  @media (max-width: 1680px) {
    .most-visited-no-content {
      padding-top: v-bind(noContentMarginTop);
    }

    .most-visited {
      margin-top: v-bind(mvMarginTop);
      margin-bottom: v-bind(mvMarginBottom);
      padding-top: v-bind(mvPaddingTop);
    }
  }
</style>
